import { Query } from '../../../../hooks/queries'
import { useContrastQuery } from '../../../../hooks/use-contrast-query'
import { ThisConnector } from '../../../../api/connector'

interface Args {
  organizationUuid: string
  searchTerm: string
}

interface Response {
  success: boolean
  messages: string[]
  applications: {
    appId: string
    appName: string
    appDisplayName: string
    appContext: string
    appArchived: false
    appLanguage: false
  }[]
}

// eslint-disable-next-line @typescript-eslint/require-await
async function query(this: ThisConnector, { organizationUuid, searchTerm }) {
  return this.connector.get(
    `/organizations/${organizationUuid}/search/applications?keyword=${searchTerm}&limit=15`
  )
}

export const useApplicationSearchFilter = ({
  organizationUuid,
  searchTerm
}: Args) => {
  const { isLoading, error, data } = useContrastQuery<Args, Response>(
    [Query.APPLICATION_SEARCH_FILTER, organizationUuid, searchTerm],
    query,
    {
      organizationUuid,
      searchTerm
    },
    {
      enabled: !!searchTerm?.length,
      cacheTime: 30000
    }
  )

  return {
    isLoading,
    error,
    data
  }
}
